import { z } from "zod";

export const schema = z.object({
	active: z.boolean(),
	id_forma: z.number().int().min(1, "Forma de Pagamento é obrigatório"),
	id_conta: z.number().int().min(1, "Nome do banco é obrigatório"),
	primeiro_lancamento: z.date(),
	cobrar_dia: z.number().int().min(1, "Cobrar Dia é obrigatório"),
	qtde_parcelas: z.preprocess((val) => (isNaN(val) ? 0 : val), z.number().min(1, { message: "Campo obrigatório" })),
	status: z.boolean().default(false),
	valor_total: z.union([z.string(), z.number()]).transform((value) => {
		if (typeof value === "string") {
			const parsedValue = parseFloat(value.replace(",", "."));
			return isNaN(parsedValue) ? 0 : parsedValue;
		}
		return value; // Já é número, mantém como está
	}),
	id_tipo_repeticao: z.number().int().min(1, "Tipo de Repetição é obrigatório"),
});
